export const getOrigin = () => {
  return window.location.origin
}

export const setHref = (newHref: string) => {
  window.location.href = newHref
}
